export enum ECourierPaymentConfirmationStatus {
  Pending = 0,

  Confirmed = 1,

  Rejected = 2,
}
